module.exports = __webpack_public_path__ + "static/media/journal.daab761e.png";